import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@ds';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { Uuid } from '@/api/types';

type OpoRequestCheckboxProps = {
  hasPermission: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  reAllocationCaseId?: Uuid | null;
};

export const OpoRequestCheckbox = memo(({ hasPermission, isDisabled, isReadOnly }: OpoRequestCheckboxProps) => {
  const { control, trigger, setValue } = useFormContext<CaseFormType>();

  const handleValueChange = (value: boolean) => {
    setValue('opoRequest', value, { shouldDirty: true, shouldValidate: true });
    trigger('txCenterId');
    trigger('txCenterCustomLocation');
    trigger('opoContactId');
  };

  return (
    <Controller
      name="opoRequest"
      control={control}
      render={({ field, fieldState: { invalid } }) => (
        <Checkbox
          {...field}
          size="md"
          value="opoRequest"
          isDisabled={!hasPermission || isDisabled}
          isReadOnly={isReadOnly}
          isSelected={!!field.value}
          isInvalid={invalid}
          onValueChange={handleValueChange}
        >
          <div className={invalid ? 'text-danger-30' : ''}>OPO Request</div>
        </Checkbox>
      )}
    />
  );
});
